export class BaseService {
    context: jsx.AppGlobals;

    constructor(context: jsx.AppGlobals, ret: object) {
        Object.assign(this, ret);
        this.context = context;
    }
}
